import { render, staticRenderFns } from "./SurfaceDesignTextureNew.vue?vue&type=template&id=677a081c"
import script from "./SurfaceDesignTextureNew.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignTextureNew.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignTextureNew.vue?vue&type=style&index=0&id=677a081c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports